import React, { type ReactNode } from 'react';
import { Banner } from '@talbenmoshe/trip-os-design-system';
import { SignInNotice } from '@talbenmoshe/trip-os-react-model';
import { useMessages } from '../i18n/messagesContext.js';

export interface SignedOutNoticeProps {
  notice: SignInNotice;
}

/** "You’ve signed out" (frame E2), drawn above the sign-in heading when the login site opens right after a sign-out. */
export function SignedOutNotice({ notice }: SignedOutNoticeProps) {
  const messages = useMessages();
  let banner: ReactNode = null;

  if (notice === SignInNotice.SIGNED_OUT) {
    banner = <Banner tone="info" title={messages.SIGN_IN_SIGNED_OUT_TITLE()} body={messages.SIGN_IN_SIGNED_OUT_BODY()} />;
  }

  return banner;
}
